import React from 'react'
import styled from 'styled-components'
import { colors, spacing } from 'src/constants/marketing-ds'

const Navigation = () => {
  return (
    <Nav>
      <NavContent>
        <NavLeft>
          <Logo
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cb/Fubo_2023.svg/1200px-Fubo_2023.svg.png"
            alt="Fubo"
          />
          <Divider />
          <TransparencyLabel>Transparency Center</TransparencyLabel>
        </NavLeft>
        <HelpLink href="https://support.fubo.tv/hc/en-us" target="_blank" rel="noreferrer">
          Help Center
        </HelpLink>
      </NavContent>
    </Nav>
  )
}

export default Navigation

const Nav = styled.nav`
  border-bottom: 1px solid ${colors.slate[160]};
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`

const NavContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 ${spacing.md};
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const NavLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
`

const Logo = styled.img`
  height: 24px;
  width: auto;
`

const Divider = styled.div`
  height: 24px;
  width: 1px;
  background-color: ${colors.slate[160]};
`

const TransparencyLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: ${colors.slate[100]};
  text-transform: uppercase;
  letter-spacing: 0.1em;
`

const HelpLink = styled.a`
  font-size: 14px;
  font-weight: 700;
  color: ${colors.slate[100]};
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: ${colors.orange[90]};
  }
`

